/**
 * Which manual install instructions to show when the browser gives us no install prompt
 * (beforeinstallprompt): iOS never fires it, Firefox/Safari desktop don't either, and Chrome
 * stops firing it once the app is installed.
 */
export type InstallPlatform = 'installed' | 'ios' | 'android' | 'desktop';

export function detectInstallPlatform(userAgent: string, isStandalone: boolean, maxTouchPoints = 0): InstallPlatform {
  if (isStandalone) return 'installed';
  // iPadOS 13+ reports itself as a Mac; the touch screen gives it away.
  if (/iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return 'desktop';
}

export function currentInstallPlatform(): InstallPlatform {
  const standalone =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    // Safari on iOS, installed from "Adicionar à Tela de Início".
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return detectInstallPlatform(navigator.userAgent, Boolean(standalone), navigator.maxTouchPoints ?? 0);
}

export const MANUAL_INSTALL_STEPS: Record<Exclude<InstallPlatform, 'installed'>, string[]> = {
  ios: [
    'Abra esta página no Safari.',
    'Toque no botão Compartilhar (o quadrado com a seta para cima).',
    'Escolha "Adicionar à Tela de Início" e confirme.',
  ],
  android: [
    'Abra esta página no Chrome.',
    'Toque no menu ⋮ no canto superior direito.',
    'Escolha "Instalar app" ou "Adicionar à tela inicial".',
  ],
  desktop: [
    'Abra esta página no Chrome ou no Edge.',
    'Clique no ícone de instalar, no fim da barra de endereço (ou no menu ⋮ > "Instalar Licitavia").',
  ],
};
